import React from "react";

const SvgComponent = props => (
  <svg
    viewBox="10 10 21.39 20.23"
    width="5em"
    height="5em"
    style={{ margin: "0 auto" }}
    display="block"
    color="#87465b"
    {...props}
  >
    <path
      d="M24.46 15.2c-.7-.78-1.63-1.51-3.92-1.53-.9 0-2.27.2-3.33 1.33a3.45 3.45 0 0 0-.98 2.94c.03.3.46.66.16 1.25 0 0-.66 1.15-.64 1.34 0 0 0 .35.53.36 0 0 .14.02.1.32v.44s.01.13.25.2c0 0 .05.05-.02.14 0 0-.13.14.09.44.08.1.2.25.13.53 0 0-.1.55.11.68 0 0 .25.29 1.23.17.34-.04.98-.21 1.36.26 0 0 .9 1.72.97 2.13 0 0 1.54-2.75 3.43-3.17 0 0-.46-1.04.47-2.38 0 0 1.17-1.54 1.2-2.4 0 0 .32-1.42-1.14-3.05z"
      fill="none"
      stroke="currentColor"
      strokeWidth={0.368}
      strokeMiterlimit={10}
    />
  </svg>
);

export default SvgComponent;



// WEBPACK FOOTER //
// ./images/personnage.svg